export const IGNORE_ERRORS = [
  'NetworkError when attempting to fetch resource.',
  'grant request is invalid',
  'Bad parameters'
]
